module.exports = __webpack_public_path__ + "media/dance-video.6a7b8b21.mp4";